import { render, staticRenderFns } from "./MyPageCommented.vue?vue&type=template&id=12c68411&"
import script from "./MyPageCommented.vue?vue&type=script&lang=ts&"
export * from "./MyPageCommented.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports